import { useCallback, useEffect, useState } from "react";
import { api } from "@/api/client";
import { WA_EVENT } from "@/utils/whatsapp";

export type WaStatus = { connected: boolean; status: string; phone: string | null; connected_at: string | null; provider: string; mocked: boolean; gateway_status?: string | null; error?: string | null };

export const emitWaChanged = (s: WaStatus) => window.dispatchEvent(new CustomEvent(WA_EVENT, { detail: s }));

export function useUserWhatsApp(enabled = true, pollMs = 0) {
    const [status, setStatus] = useState<WaStatus | null>(null);
    const refresh = useCallback(async () => {
        try { const r = await api.get("/user-whatsapp/status"); setStatus(r.data); return r.data as WaStatus; }
        catch { return null; }
    }, []);
    useEffect(() => {
        if (!enabled) return;
        refresh();
        const h = (e: Event) => setStatus((e as CustomEvent).detail);
        window.addEventListener(WA_EVENT, h);
        const iv = pollMs ? setInterval(refresh, pollMs) : undefined;
        return () => { window.removeEventListener(WA_EVENT, h); if (iv) clearInterval(iv); };
    }, [enabled, refresh, pollMs]);
    return { status, refresh };
}
